/** Gemeinsame Regeln mit backend/app/schemas/ip_adresse.py — nur Länge, kein Format. */

export const IP_ADRESSE_MAX_LENGTH = 500;

/** Fehlermeldung bei Überlänge, sonst null. Beliebiger Text ist erlaubt. */
export function validateIpAdresse(value: string | null | undefined): string | null {
  if (value == null) return null;
  const stripped = value.trim();
  if (stripped === '') return null;

  if (stripped.length > IP_ADRESSE_MAX_LENGTH) {
    return `IP-Adresse ist zu lang (höchstens ${IP_ADRESSE_MAX_LENGTH} Zeichen).`;
  }

  return null;
}
